<template>
  <div class="form-select">
    <select
      :class="inputStyle"
      :dir="optionAlign"
      v-on:change="updateValue($event.target.value)"
    >
      <option value="" disabled :selected="placeholderText">
        {{ placeholderText }}
      </option>
      <option
        v-for="(data, key) in optionDatas"
        :key="key"
        :value="data.value || data"
        :selected="(data.value || data) == selected"
      >
        {{ data.title || data }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    inputStyle: String,
    optionAlign: String,
    placeholderText: String,

    optionDatas: Array,
    selected: '',
  },
  data() {
    return {};
  },
  methods: {
    updateValue(selected) {
      this.$emit('selectParent', selected);
    },
  },
};
</script>

<style lang="scss" src="../scss/form-select.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/FormSelect.vue